import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";
import PDFview from "../../../../components/PdfView";

const ProcurementRecieptList = (props) => {
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [procurementRecieptId, setProcurementRecieptId] = useState(0);
  const [docurl, setDocUrl] = useState(false);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  console.log("loginUserId", loginUserId);
  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const [selecteditem, setSelecteditem] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelecteditem(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };
  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selecteditem && selecteditem.procurementRecieptId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    updateApprovalStatus(
      {
        url: "/api/approveProcurementReciept/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
      },
      (error) => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  const { sendRequest: deleteHolidays } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete these detail?",
      onOk() {
        const updatedApproveData = {
          ...data,
          status: 0,
          serviceId: serviceId,
        };

        deleteHolidays(
          {
            url: "/api/procurementReciept/",
            method: "PUT",
            body: updatedApproveData,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/procurementReciept/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.goodsTrasnferNo?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.vmeNo?.includes(filetrtext) ||
        item?.driverName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.procurementRecieptId;

    getDetailView(
      {
        url: `/api/procurementReciept/?orgId=${localStorage.getItem(
          "orgId"
        )}&procurementRecieptId=${Id}`,
      },
      (res) => {
        //console.log("Detail View", res);
        setSelectedData(res);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const viewPdf = (itemId) => {
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
    setProcurementRecieptId(itemId);
  };

  return (
    <>
      <AntModal
        title="Procurement Reciept Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <h4 className="card-title">Procurement Reciept Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div>
              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Date</label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.Date} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Field Officer </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.employeeName} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> GetPass No </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.getpassNo} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Procurement Reciept No</label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.procurementRecieptNo} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Getpass For </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.getpassType} </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Farmer/Employee Name </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.farmerName} </label>{" "}
                </div>
              </div>

              <div className="row">
                <div className="col-md-2">
                  {" "}
                  <label> Load Quantity </label>
                </div>
                <div className="col-md-1">
                  <label> : </label>{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  <label>
                    {" "}
                    {selectedData.loadQuantity} {selectedData.unitAbbreviation}{" "}
                  </label>{" "}
                </div>
                <div className="col-md-2">
                  <label> Remark/Note </label>{" "}
                </div>
                <div className="col-md-1">
                  {" "}
                  <label> : </label>
                </div>
                <div className="col-md-3">
                  {" "}
                  <label> {selectedData.remark} </label>{" "}
                </div>
              </div>
              <div className="row">
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Product Type</th>
                      <th>Product Subtype</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th>Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedData.productData &&
                      selectedData.productData.map((itm, i) => {
                        return (
                          <tr key={i} className="cursor-pointer">
                            <td>{i + 1}</td>
                            <td>{itm.productTypeName}</td>
                            <td>{itm.productSubTypeName}</td>
                            <td>{itm.productName}</td>
                            <td>{itm.itemQuantity}</td>
                            <td>{itm.unitAbbreviation}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-1">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Procurement Reciept Detail
            </label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  sId(serviceId);
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Procurement Reciept
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th> Date</th>
                            <th>Doc No</th>
                            <th>Gatepass No</th>
                            <th>Farmer Name</th>
                            <th>Assigned Supervisor</th>

                            <th>Delete</th>
                            <th>Approval</th>
                            <th>Approved by</th>
                            {canView === "block" && <th>View</th>}
                            {canPdf === "block" && <th>Pdf</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.Date}</td>
                                <td>{x.procurementRecieptNo}</td>
                                <td>{x.getpassNo}</td>
                                <td>{x.farmerName}</td>

                                <td>{x.employeeName}</td>
                                {canDelete === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      disabled={x.approved == 1 ? true : false}
                                      onClick={(e) => deleteOperation(e, x)}
                                    >
                                      {" "}
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </td>
                                )}

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={
                                      x.nextlevel == 1
                                        ? x.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : x.approved == 0 &&
                                          x.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>{x.approvedByName}</td>
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(x)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                                {canPdf === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() =>
                                        viewPdf(x.procurementRecieptId)
                                      }
                                    >
                                      <i className="fas fa-solid fa-file"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {docurl && (
        <Modal isOpen={true} style={customModalStyles}>
          {procurementRecieptId && (
            <div className="row">
              <div className="col-md-11">
                <button
                  className="btn btn-sm btn-success"
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_BASE_URL}/api/procurementReciept_pdf/?procurementRecieptId=${procurementRecieptId}`,
                      "_blank"
                    )
                  }
                >
                  Download
                </button>
              </div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setDocUrl(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>
          )}
          <PDFview
            docurl={`${process.env.REACT_APP_BASE_URL}/api/procurementReciept_pdf/?procurementRecieptId=${procurementRecieptId}`}
          />
        </Modal>
      )}
    </>
  );
};

export default ProcurementRecieptList;
